module.exports = __webpack_public_path__ + "static/JessicaCornel-9a6dcac04e562b1abc53fcdad395259e.jpg";